module.exports = __webpack_public_path__ + "img/img2.b64e6f3d.jpg";